export default __webpack_public_path__ + "static/media/info2.41a75b74.svg";